import axios from "axios"
import * as actions from "../actions/user"

export function addUser(user) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/`, user)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.addUser(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getUser(userId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/user/${userId}`)
      .then(response => { 
        let user = response ? response.data : {}
        dispatch(actions.getUser(user))
      })
  }
}

export function getUsers() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/user`)
      .then((response) => {
        let users = response.data ? response.data.$values : []
        dispatch(actions.getUsers(users))
      })
  }
}

export function updateUser(user) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/user/`, user)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.updateUser(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function clearUser() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearUser())
      resolve()
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/user.js